import { Link } from 'react-router-dom';
import PhotoMotion from '@/components/feature/PhotoMotion';
import { cdn } from '@/config/cdn';

export default function Shared() {
  return (
    <section className="bg-[#F5F1EB] text-[#171515] py-20 md:py-32" aria-labelledby="shared-heading">
      <div className="fold-shell grid grid-cols-1 lg:grid-cols-12 gap-y-10 lg:gap-x-8 items-end">
        <div className="lg:col-span-7 min-w-0">
          <div className="w-full aspect-[4/5] sm:aspect-[4/3] overflow-hidden bg-[#e4e0da]">
            <PhotoMotion fromScale={1.05} fromY={22} duration={1.25} parallax={18}>
            <img
              src={cdn('https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_story-shared.webp')}
              alt="The FOLD. bakery counter on a quiet morning"
              title="The counter — FOLD. Artisan Bakery"
              className="w-full h-full object-cover object-center"
            />
            </PhotoMotion>
          </div>
        </div>
        <div className="lg:col-span-5 min-w-0">
          <p className="fold-label text-[#8A8580]">04 — Made to be shared</p>
          <h2 id="shared-heading" className="mt-6 fold-serif uppercase leading-[0.92] tracking-[-0.03em] text-[11vw] sm:text-[8vw] lg:text-[4.6vw] xl:text-[4.8rem]">
            Made for the<br /><span className="italic">moments</span><br />between.
          </h2>
          <p className="mt-8 text-[15px] md:text-base leading-[1.75] text-[#5d5853] max-w-[380px]">
            Something warm from the oven. A familiar morning. A reason to come back.
          </p>
          <div className="mt-10 flex flex-wrap gap-x-10 gap-y-4">
            {[{ to: '/collection', t: 'See the collection' }, { to: '/visit', t: 'Plan a visit' }].map((l) => (
              <Link key={l.to} to={l.to} className="group inline-flex items-center gap-2 fold-label whitespace-nowrap cursor-pointer">
                <span className="bg-[linear-gradient(currentColor,currentColor)] bg-no-repeat bg-left-bottom bg-[length:100%_1px] group-hover:bg-[length:0%_1px] transition-[background-size] duration-500 pb-1">{l.t}</span>
                <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true"></i>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}